import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs, characters } from "@/mocks/characters";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "/faq" },
    ],
  },
];

export default function Faq() {
  return (
    <Layout>
      <Seo
        title="继母与继姐漫画常见问题 - 主角/继母/继姐角色关系答疑"
        description="继母与继姐漫画常见问题汇总：主角是谁、继母角色位置、继姐与主角关系、人物关系走向等高频疑问一次讲清。"
        keywords="继母与继姐漫画常见问题,继母与继姐漫画主角,继母与继姐漫画继母角色,继母与继姐漫画继姐角色"
        jsonLd={jsonLd}
      />
      {/* 页头 */}
      <section className="bg-gradient-to-b from-background-100 to-background-50 pt-24 md:pt-32">
        <div className="mx-auto max-w-3xl px-4 pb-10 md:px-6 md:pb-14">
          <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="transition-colors hover:text-primary-700">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题 · FAQ
          </h1>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            关于「继母与继姐」漫画的主角、继母角色、继姐角色以及人物关系的常见疑问，这里为你集中解答。
          </p>
        </div>
      </section>

      {/* FAQ 列表 */}
      <section className="mx-auto max-w-3xl px-4 pb-14 md:px-6 md:pb-20">
        <FaqAccordion items={faqs} />

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-6 text-center">
          <h2 className="font-heading text-lg font-bold text-foreground-950">还有疑问？</h2>
          <p className="mt-2 text-sm text-foreground-600">
            想进一步了解三位角色与关系走向，可以回到角色详解与人物关系页面查看完整梳理。
          </p>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/characters"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看角色详解
            </Link>
            <Link
              to="/relationships"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看人物关系
            </Link>
          </div>
        </div>
      </section>

      {/* 相关角色 */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">相关角色速览</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              认识了关系，再来认识这三位角色本人。
            </p>
          </div>
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {characters.map((c) => (
              <Link
                key={c.id}
                to={`/characters#${c.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-transform duration-300 hover:-translate-y-1"
              >
                <img
                  src={c.image}
                  alt={`继母与继姐漫画${c.role}${c.name}`}
                  title={`${c.name} ${c.role}`}
                  className="h-16 w-16 shrink-0 rounded-full object-top object-cover"
                />
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                  <p className="text-xs text-primary-600">{c.role}</p>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{c.tagline}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}